import service from './axios';
import service1 from './axios1';


// 策略列表
export function getStrategy(data) {
  return service({
    // url: '/strategy/api/strategies',
    url: "strategy/api/strategies/return-rates/",
    method: 'get',
    params: data
  })
}
// 策略详情
export function getStrategydetails(data) {
  return service({
    // url: `/strategy/api/strategies/${id}/details/`,
    url:`add/manage_get/`,
    method: 'get',
    params: data
  })
}
// 历史订单
export function getStrategyhistory(id,data) {
  return service({
    url: `/strategy/api/strategies/${id}/history/`,
    method: 'get',
    params:data
  })
}
//策略详情饼状图（品种偏好）
export function getStrategypie(id) {
  return service({
    // url: `/strategy/strategy/${id}/variety-pie-chart/`,
    url:`add/picture_kind/?account=${id}`,
    method: 'get',
  })
}
// 收益率柱状图
export function getStrategyreturnrate( data) {
  return service({
    // url: `/strategy/strategy/${id}/strategy_return_rate/`,
    // url:`/add/picture_roi/`,
    url:`/add/picture/`,
    method: 'get',
    params: data
  })
}
// 资金曲线
export function getStrategybalance(data) {
  return service({
    // url: `/strategy/strategy/${id}/balance-line-chart/`,
    url:`/add/picture/`,
    method: 'get',
    params: data
  })
}
// 净值回撤
export function getStrategydrawdown(id, data) {
  return service({
    url: `/strategy/strategy/${id}/strategy_net_drawdown/`,
    method: 'get',
    params: data
  })
}
// 登录
export function login(data) {
  return service({
    url: '/auth/api/token/',
    method: 'post',
    data,
  })
}
// 注册验证码
export function verification(data) {
  return service({
    url: '/auth/get-verification-code/',
    method: 'post',
    data,
  })
}
// 注册
export function register(data) {
  return service({
    url: '/auth/register_code/',
    method: 'post',
    data,
  })
}
// 修改密码验证码
export function updatecode(data) {
  return service({
    url: '/auth/update_code/',
    method: 'post',
    data,
  })
}
// 修改密码验证码
export function updatepwd(data) {
  return service({
    url: '/auth/update/',
    method: 'post',
    data,
  })}
export function getUserInfo(userId) {
  return service.get(`/users/${userId}/`);
}

// 公司列表
export function getCompanyList() {
  return service.get('/strategy/api/companylist/');
}

// 公司投诉
export function getComplaintList() {
  return service.get(`/complaint/api/complaints/`);
}
//发表投诉
export function postComplaint(data) {
  return service.post('/complaint/api/complaint_send/', data);
}
// 获取单个公司详情
export function getCompanyDetail(companyId) {
  return service.get(`/strategy/api/companies/${companyId}/`);
}
// 获取客服列表
export function getService() {
  return service({
    url: '/connect/api/contact_us/', 
    method: 'get'
  })
}

//公司策略列表
export function getCompanyStrategyList(companyId) {
  return service.get(`/strategy/api/companies/${companyId}/strategies/`);
}
//删除投诉
export function deleteComplaint(id) {
  return service.delete(`/complaint/api/complaints/${id}/`);
}
export function getCompanyIMG(formData) {
  return service({
    url: '/ckeditor/upload/',
    method: 'post',
    data: formData,
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })}

//公司列表
export function QgetCompanyList() {
  return service.get('complaint/api/complaint_list/');
}

// 获取用户信息
// export function getUserInfo(userId) {
//   return service.get(`/users/${userId}/`);
// }

//公司列表
// export function YgetCompanyList() {
//   return service.get(`/strategy/api/companylist/`);
// }

//机构动态
export function getCompanyNews(){
  return service.get(`/companynews/api/company_news/`);
}
//查看新闻(热门)
export function getHotNews(){
  return service.get(`/news/api/articles/?category=hot`);
}
//查看新闻(最新)
export function getNews(){
  return service.get(`/news/api/articles/?category=all`);
}
//查看新闻(要闻)
export function getImportantNews(){
  return service.get(`/news/api/articles/?category=news`);
}
//查看新闻(快讯)
export function getFlashNews(){
  return service.get(`/news/api/articles/?category=flash`);
}

// 通过id获取详情数据
export function getDetailById(id) {
  return service.get(`/companynews/api/company_news/${id}/`);
}
// 通过id获取详情数据
export function getNewsById(newsid) {
  return service.get(`/news/api/articles/${newsid}/`);
}
//广告位
export function getadvert(){
  return service.get(`/advert/api/ad/`);
}
//成员文章
export function getMemberNews(id){
  return service.get(`/companynews/api/companynews/${id}/`);
}


// 持仓订单
// export function getPositionorders(id){
//   return service1.get(`/api/v2/account/my_signals/position_order_detail/?account=${id}`);
// }
export function follower_p_data(data) {
  return service({
    // url: '/v2/account/my_signals/position_order_detail/',
    url:'/add/manage_get_close/',
    method: 'get',
    params: data,
  })
  // return request.get('/v2/account/my_signals/close_order_detail/?account=' + accountlist + '&page=' + data.page + '&ordering=' + data.sort + '&status=' + data.status + '&ticket=' + data.ticket)
}
// 平仓历史订单
export function follower_c_data(data) {
  return service({
    // url: '/v2/account/my_signals/close_order_detail/',
    url:'/add/manage_get_position/',
    method: 'get',
    params: data,
  })
}
// 获取单独的token

export function synctoken() {
  return service({
    url: 'add/sync/',
    method: 'post',
  })
}

// 交易管理模块
export function manage_get_history(data) {
  return service({
    url:'/add/manage_get_history/',
    method: 'get',
    params: data,
  })
}